import { Typography } from 'antd'
import * as React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'

import * as styles from './Breadcrumb.module.less'

const { Text } = Typography

export interface BreadcrumbProps {
    isLast?: boolean
    label: React.ReactNode
    Link?: any
    url?: string
    onLinkClick?: (path: string) => void
}

export const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
    const { isLast, label, url } = props

    const Link = props.Link !== undefined ? props.Link : ReactRouterLink

    const onClick = () => {
        if (props.onLinkClick) {
            if (url) {
                props.onLinkClick(url)
            }
        }
    }

    return url ? (
        <Link to={url} onClick={onClick}>
            <Text
                className={styles.breadcrumb}
                // type={isLast ? null : 'secondary'}
                type={'secondary'}
            >
                {label}
            </Text>
        </Link>
    ) : (
        <React.Fragment />
    )
}
